import React from 'react';
import { connect } from 'react-redux';

import Table from '../Table/Table'
import Loader from '../Loader/Loader'
import './ListContainer.scss';
import { Input, Button } from 'reactstrap'

import { Fire, Time } from '../../../services'

import FadeIn from 'react-fade-in';

const { useHistory, useRouteMatch } = require('react-router-dom')

interface Props {
  title: string;
  searchTitle?: string;
  createTitle?: string;
  paginationTitle?: string;
  error?: string;

  sorting: (search: string, items: any[]) => any[];
  onFetch: () => Promise<any[]>;
  onCreate?: () => void;
  onSelect?: (item: any) => void;
  renderColumns: (tools: any) => any[];
  expandableRow?: (item: any, tools: any) => any;
}
const ListContainer: React.FC<Props> = (props: Props) => {
  
  const [items, setItems] = React.useState<any[]>([])
  const [data, setData] = React.useState<any[]>([])
  const [columns, setColumns] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState('')
  const history = useHistory()

  const refresh = async () => {
    setLoading(true)
    try {
      setItems(await props.onFetch())
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }

  React.useEffect(() => {
    refresh()

  }, [])

  React.useEffect(() => {
    setData(props.sorting(search, items))
  }, [items, search])

  React.useEffect(() => {
    setColumns(props.renderColumns({ refresh }))
  }, [props.renderColumns])

  const expandedRow = (item: any) => {
    if (!props.expandableRow)
      return undefined
    return props.expandableRow(item, refresh)
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="row-header">
          <h3 className="card-title">{props.title}</h3>
          { props.onCreate &&
            <div>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={props.onCreate}
                >
                {props.createTitle || 'Ajouter un élément'}
              </button>
            </div>

          }
        </div>
      </div>

      <div className="card-body">
        { props.error && props.error.length > 0 &&
          <div style={{marginBottom: 14}}>
            <div className="text-danger">{props.error}</div>
          </div>
        }

        { loading ? (
          <Loader />
        ) : (
          <Table
            data={data}
            columns={columns}
            onRowClicked={props.expandableRow ? undefined : props.onSelect}
            
            searchTitle={props.searchTitle || 'Rechercher...'}
            expandableRow={expandedRow}
            />
        )}
        
      </div>
    </div>
  );
}

export default ListContainer